import {Component, EventEmitter, Output} from "@angular/core";

@Component({
    selector: 'web-picture-upload',
    templateUrl: './picture-upload.html',
    styleUrls: ['./picture-upload.scss']
})
export class PictureUploadComponent{

    @Output() fileChosen:EventEmitter<File> = new EventEmitter<File>();

    public file:File;
    public picture:any;


    FileChosen(files: FileList){
        this.file = files.item(0);
        this.fileChosen.emit(this.file);
        this.DisplayImage(this.file);
    }

    private DisplayImage(file:File):any{
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = (event) => {
            this.picture = event.target['result'];
        };
    }
}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/picture-upload/picture-upload.ts